import { isViewInReadMode } from '../abstractions/office';

export function assignMetricModeContext(name: string) {
  if (!name.includes('task_pane')) {
    return name;
  }

  const parts = name.split('.');
  const metric: string[] = [];
  let found = false;
  for (let index = 0; index < parts.length; index++) {
    const part = parts[index];
    metric.push(part);
    if (part === 'task_pane' && !found) {
      found = true;
      metric.push(isViewInReadMode() ? 'read_view' : 'compose_view');
    }
  }
  return metric.join('.');
}
